import { render, staticRenderFns } from "./ListaIndicadores.vue?vue&type=template&id=1743b806"
import script from "./ListaIndicadores.vue?vue&type=script&lang=js"
export * from "./ListaIndicadores.vue?vue&type=script&lang=js"
import style0 from "./ListaIndicadores.vue?vue&type=style&index=0&id=1743b806&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1743b806')) {
      api.createRecord('1743b806', component.options)
    } else {
      api.reload('1743b806', component.options)
    }
    module.hot.accept("./ListaIndicadores.vue?vue&type=template&id=1743b806", function () {
      api.rerender('1743b806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/DashboardReportNMV/components/generic/ListaIndicadores.vue"
export default component.exports